import * as i0 from '@angular/core';
export const ApplicationModuleNgFactory:i0.NgModuleFactory<i0.ApplicationModule> = (null as any);
var _decl0_0:i0.TemplateRef<any> = (<any>(null as any));
var _decl0_1:i0.ElementRef = (<any>(null as any));
